import { PortableTextBlock } from 'next-sanity'

// Sanity content types for TypeScript

export interface SanityTalentStory {
  _id: string
  name: string
  slug: {
    current: string
  }
  position: string
  company?: string
  quote: string
  body?: PortableTextBlock[]
  photo: {
    asset: {
      _ref: string
      _type: string
    }
    alt?: string
  }
  isPublished: boolean
  publishedAt: string
}

export interface SanityTeamMember {
  _id: string
  name: string
  role: string
  bio?: PortableTextBlock[] // Portable Text
  photo: {
    asset: {
      _ref: string
      _type: string
    }
    alt?: string
  }
  linkedin?: string
  order: number
  isActive: boolean
  isBoardMember: boolean
}

export interface SanityPartner {
  _id: string
  name: string
  logo: {
    asset: {
      _ref: string
      _type: string
    }
    alt?: string
  }
  website?: string
  partnerType: 'industrial' | 'funder' | 'community' | 'training'
  isActive: boolean
  order: number
}

export const FAQ_CATEGORIES = [
  'Companies',
  'Talents',
  'Volunteers',
  'Seniors',
  'Local Partners',
] as const

export type Category = (typeof FAQ_CATEGORIES)[number]

export interface SanityFAQ {
  _id: string
  question: string
  answer: PortableTextBlock[]
  category: Category
  isPublished: boolean
  featured: boolean
  order: number
}

export interface SanityImpact {
  _id: string
  title: number
  subtitle: string
  icon: {
    asset: {
      _ref: string
      _type: string
    }
    alt?: string
  }
  suffix?: string
  order: number
  isActive: boolean
}

export interface SanityClientStory {
  _id: string
  companyName: string
  slug: {
    current: string
  }
  title: string
  summary: string
  body?: PortableTextBlock[]
  companyLogo: {
    asset: {
      _ref: string
      _type: string
    }
    alt?: string
  }
  coverImage: {
    asset: {
      _ref: string
      _type: string
    }
    alt?: string
  }
  isPublished: boolean
  publishedAt: string
}

export interface SanityPress {
  _id: string
  publication: string
  articleTitle: string
  articleUrl: string
  image: {
    asset: {
      _ref: string
      _type: string
    }
    alt?: string
  }
  publishedDate?: string
  order: number
  isActive: boolean
}
